import * as React from 'react';
import Svg, { Defs, Path, G, Rect, Text, TSpan } from 'react-native-svg';
/* SVGR has dropped some elements not supported by react-native-svg: filter */

export const ExploreGeneral = (props) => {
  return (
    <Svg width="163px" height="98px" viewBox="0 0 163 98" {...props}>
      <Defs>
        <Path d="M16.183.006a6.576 6.576 0 00-4.329 1.877l-.354.348-.355-.348c-2.55-2.51-6.683-2.51-9.233 0a6.356 6.356 0 000 9.089l8.878 8.738a1.016 1.016 0 001.42 0l8.877-8.738A6.375 6.375 0 0023 6.427c0-1.704-.688-3.34-1.913-4.544A6.58 6.58 0 0016.471 0l-.288.006zm.288 1.971c1.199 0 2.348.469 3.196 1.304a4.414 4.414 0 011.325 3.146c0 1.18-.477 2.312-1.325 3.147L11.5 17.613l-8.168-8.04a4.4 4.4 0 010-6.292 4.571 4.571 0 016.393 0l1.065 1.048a1.016 1.016 0 001.42 0l1.064-1.048a4.556 4.556 0 013.197-1.304z" />
      </Defs>
      <G stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <Path fill="#FFF" d="M0 0H1300V7847H0z" />
        <G>
          <Rect fill="#FCE8F0" x={0} y={0} width={163} height={98} rx={7} />
          <Text fontSize={12} fontWeight={500} letterSpacing={-0.14} fill="#EA236C">
            <TSpan x={12} y={22}>
              General
            </TSpan>
          </Text>
          <Path
            d="M148.032 77.843c-9.312 15.58-52.68 12.442-65.053-4.82-12.373-17.262 6.123-48.535 27.807-46.966 21.684 1.681 46.43 36.093 37.246 51.786z"
            fill="#EA236C"
            fillRule="nonzero"
          />
        </G>
        <Path
          d="M145.84 46.714c-.02.025-.022.03.012.031l-.012-.03zm.273-12.379c-.015-.072-.042-.087-.105-.056.023.072.035.118.105.056zm-.634 15.243c.068-.02.088-.053.072-.12-.072.024-.127.03-.072.12zm3.27 4.378c-.207-.117-.208-.146-.38-.084.134.125.144.102.38.084zm-3.155-3.837c-.267-.09-.277-.122-.456.007.183.112.19.074.456-.007zm.93 1.679c.75-.168-.207-.391-.513-.259l.513.259zm-1.211-5.358c-.423.117-.509.238-.086.383.245-.056.386-.228.086-.383zm-2.258-6.106c.274-.1.464-.464.075-.401-.302.13-.448.208-.075.4zm3.977 7.456c-.47.035-.752-.085-1.07.068.429.02.693.329 1.07-.068zm-1.165-12.566c-.61.107.028.335.324.293.54-.061-.003-.327-.324-.293zm3.21 17.026c.798-.263-.41-.082-.48-.592-.485.236.184.62.48.592zm-5.004-6.77c-.33-.105-.78-.608-.922-.034.152.373.645.092.922.034zm.343 1.83c.738.039.324-.507-.241-.379-.713.172-.186.38.241.378zm2.03.035l1.048-.192c-.447-.28-2.106-.117-1.049.192zm.177 3.713c.928-.343-.849-.656-1.177-.446l1.177.446zm1.847 1.76c1.931-.466-.247-.458-.534-.335-.046.206.245.38.534.336zm-3.648-16.097c-1.376.2.29.67.796.388l-.796-.388zm3.7 15.207c-.896.038-1.195-.162-1.787.234.73.363.995-.058 1.787-.234zm-2.495-13.51c1.093-.277-1.352-.622-1.514-.37.377.305 1.132.337 1.514.37zm-.773.426c.892-.098-2.026-.868-1.84-.506.15.343 1.607.436.538.535-.096.005-.216-.226-.275-.02.18.604 1.155.051 1.577-.009zm.74-2.748c-2.08.293-2.122.334.023.4.766.296 1.893-.482-.023-.4zm-1.933 10.311c.469.32.676-.243 1.032-.27.17-.24-.49-.428-.65-.614-.254.755-.383.354-.867.546-.774.65-.144.866.485.338zm1.613-4.983c-.3-.106-1.427-.375-2.032-.2-.546.765 1.092.272 1.447.82.443.475.664-.068.133-.293-.868-.332-.526-.216.452-.327zm2.71 13.997c.098-1.364.348-.46 1.152-1.204-.307-.264-2.584.06-2.374.219.945.283.143 1.016 1.222.985zm-3.32-12.703c.535-.208-.378-.309-.582-.48-.036-.025.343-.002.19-.195-.385-.09-1.231.284-1.587.061-.804-.513-.659.805-1.248.593 1.957.805.997-.695 3.226.02zm.359 5.769c-1.833-.304-1.08 1.264-.277.997.177-.927.613.479 2.747-.385.297-.06.463-.486.037-.515-.99.293-3.384-1.45-2.507-.097zm-.086-12.641c-1.105-.042-1.525-1.232-1.715.213 1.084-.46 1.6.26 1.715-.213zm1.604-2.348c1.542 3.993 1.457 6.08-3.136 6.046-1.733-1.002.408 1.64.99.241.13-.315.898-.265.597.056.162.372.415-.46.753-.018.548.11.05.886-.349.735-.956-.69-1.932.214-2.879-.104.343 1.097 3.166-.41 3.711.824-1.208 1.645.764 2.738-1.955 2.644-.13.28.395.129.215.383-.068.087-.416.071-.538-.026-.637-.667-3.184-.335-1.3-.142 1.115.425.714.356-.17.257.915.398 2.065.469 3.083.83 1.123-.142-1.831-.756-.39-.984 1.585.506 1.189 2.933 2.84 3.568.766.227-.533.618.328.238.113-.014.303-.014.182.213-.918.628.247.83.287 1.285.033.366.613.943.325 1.082-.496.246-1.166.06-1.703-.244 2.198-.382-1.31-1.006-1.9-.233 1.569-.098.262.309.93.41.918-.051 1.698.652 2.65.47 1.602 1.633-.579 6.748-3.074 4.42.805-.122.847-.124.306-.838-.203-.222-.494-.077-.718.01-.297.121.228.231.01.379-.31-.017-.69-.117-.526.32.181.434-.545 1.331.625 1.265 1.193-.182 1.134.503-.016.474-2.009.05-2.443-3.228-.848-4.045-4.425-11.18-4.57-7.338-2.41-19.035-.075-.726 2-.378 1.573.355-.627.718 1.098.835.464.428-.146-.072-.507-.04-.257-.217.35.34.319-.621.65-.2.072.094.102.196.19.101.212-1.209-1.202-.743 1.46-.948z"
          fill="#FFA28F"
          fillRule="nonzero"
          transform="rotate(90 145.781 45.28)"
        />
        <Path
          d="M62.401 80.195c-1.836 2.754-6.14 2.377-7.163-.797-2.003-7.271 9.339-12.491 7.163.797"
          fill="#FFFE02"
          fillRule="nonzero"
          transform="rotate(90 58.84 77.02)"
        />
        <Path
          d="M92.185 67.575c-.034-.035-.05-.096-.1-.044.035.037.047.099.1.044m-3.598-6.71c.075-.082.013-.114-.07-.131-.1.06-.03.093.07.13m3.761 3.773l.665-.452c-.251-.069-1.228.199-.665.452m.59 2.965c-.626.158.64.72.987.474l-.986-.474M80.909 50.54c.29-1.255-2.176.012-.995-.001.331-.585.863.416.996.001m7.687 9.754c-.976.134.709.49 1.03.465.652-.04 1.291-.848 1.946.033.046.062.274-.006.414-.032-.452-1.217-2.455.042-3.39-.466m-9.157-2.74c.123-.488 1.747-.539 1.511-.829-1.247.13-4.71.565-1.51.83m3.159 3.758c-.896-.181-.643-.702.032-1.04-6.016.159 3.297 2.772 5.226 2.882 1.448-.361 3.676 3.005 3.74 2.067-.245-.598-2.83-2.399-1.23-1.894.751.173 1.328 1.103 2.078.443.282-.397-1.02.32-1.016-.266-.067-.435 1.044-.113.357-.469-1.768.164-8.856-.683-8.545-1.849-.31-.14-.842-.398-.642.126m-.777 1.448c-5.2-1.461-6.253-11.177-2.145-12.926-1.651-.294.188-1.72.627-1.08.536.822 2.153-.076 1.902 1.455-3.013 13.796 10.207 4.448 13.218 12.262 1.001 2.862-.907 12.354-4.78 9.225.838-.852-1.498-.45-.358-1.8 1.862-6.844-3.846-5.744-8.464-7.136"
          fill="#FFA28F"
          fillRule="nonzero"
          transform="rotate(90 86.423 60.456)"
        />
        <Path
          d="M138.836 67.758c-.075.023-.108.048-.01.079.063.002.038-.041.01-.08m-4.358 5.102c.278-.093-.221-.377-.355-.491-.568.103-.138.59.355.491m-3.884-.606c-.632.106.93.568 1.149.322l-1.15-.322m2.964-1.7c.374-.188.826-.016 1.07-.415-.162-.246-1.385.197-1.07.415m-.785 1.538c1.156-.33-1.188-.584-1.85-.12.662.382 1.137-.173 1.85.12m-1.35-1.333c-4.702-.405 5.318-1.634 6.565-2.633 2.16-.863 4.81-7.175 6.146-2.099-.127 6.574-13.505 7.657-18.195 11.358-5.776-1.827 2.629-7.681 6.394-6.07-2.464-.146-.4-.369-.91-.556"
          fill="#FFA28F"
          fillRule="nonzero"
          transform="rotate(90 134.051 70.728)"
        />
        <Path
          d="M40.443 71.366c-.292-.04-.343-.076-.506.11.227.047.26.047.506-.11m-.248-.273c.508.237.546.418.914.137-.262-.258-.393-.099-.914-.137m-4.68-.722c.735-.1-.238-.493-.51-.282.173.095.346.19.51.282m-5.335-7.042c.504-.121.423-.22-.045-.276-.51.104-.465.198.045.276m1.122 1.323c-.804.19.798.445.704.01-.167-.536-.433.286-.704-.01m3.726 3.162c-.196-.306-.433-.094-.59-.03-1.628.28-.225.36.59.03m-1.046 1.728c1.364-.06-.574-.405-1.051-.17.281.344.65.102 1.05.17m4.353.969c-.872.373 1.094.43 1.484.543.692-.311-1.058-.417-1.484-.543m-.355 1.176c-5.054.672-13.572-9.07-5.732-9.72 4.314 10.359 7.062 3.35 13.056 8.631.842.836-.16.981-.748 1.291 4.409-.566 1.793 6.713-.81 2.688-1.137-1.75-4.012-3.357-5.766-2.89"
          fill="#FFA28F"
          fillRule="nonzero"
          transform="rotate(90 37.998 68.882)"
        />
        <Path
          d="M114.829 86.886c-5.613-.714-3.695-9.336 1.406-8.862 4.83 1.277 3.473 9.346-1.406 8.862"
          fill="#FFFE02"
          fillRule="nonzero"
          transform="rotate(90 115.333 82.456)"
        />
        <Path
          d="M134.506 33.383c-4.832.518-4.61-8.963.522-7.737 4.974.327 4.398 7.957-.522 7.737"
          fill="#FFFE02"
          fillRule="nonzero"
          transform="rotate(90 134.757 29.47)"
        />
        <Path
          d="M71.873 46.258c.113-.86-.643-.962-1.117-1.293-3.025-2.348 1.426-7.15 4.435-5.014 3.625 1.8 1.727 8.643-2.632 6.465.987-.637-.139-.358-.686-.158"
          fill="#FFFE02"
          fillRule="nonzero"
          transform="rotate(90 73.424 43.128)"
        />
        <Path
          d="M40.456 86.733c-1.805-1.614-4.164-1.8-4.507.481.485.872-.72.251-.64.755.204.28.396.57.614.839 5.338 6.66 9.354 1.94 4.533-2.075"
          fill="#0230BC"
          fillRule="nonzero"
          transform="rotate(90 38.96 88.826)"
        />
        <Path
          d="M110.323 37.27c-1.603-2.433-4.403-3.94-6.548-5.905-.866-.645-.732 1.157-1.7.941-5.358 2.14 7.802 11.982 8.248 4.964"
          fill="#0230BC"
          fillRule="nonzero"
          transform="rotate(90 105.559 35.49)"
        />
        <Path
          d="M118.826 59.73c-6.006-4.856-16.171 16.64-.5 2.503 1.32-.852.303-1.698.5-2.503"
          fill="#0230BC"
          fillRule="nonzero"
          transform="rotate(90 114.508 63.062)"
        />
        <Path
          d="M159.678 86.454c-2.312 1.112-8.331.426-7.512 4.178.335 3.308 4.64.586 6.642.666 2.566 0 3.715-5.098.87-4.844"
          fill="#0230BC"
          fillRule="nonzero"
          transform="rotate(90 156.715 89.36)"
        />
        <Path
          d="M64.841 63.069c4.184-1.46-2.262-7.363-4.459-7.058-3.667 2.252.71 7.96 4.46 7.058"
          fill="#0230BC"
          fillRule="nonzero"
          transform="rotate(90 62.611 59.582)"
        />
        <Path
          d="M85.179 85.744c-2.009.946-6.146 2.241-3.718 5.38 2.781.434 9.725-4.35 3.718-5.38"
          fill="#0230BC"
          fillRule="nonzero"
          transform="rotate(90 84.137 88.448)"
        />
        <Path
          d="M102.901 40.252c.038.06.06.012.074-.039-.029-.063-.057-.007-.074.04m-1.165.913c.118-.735.975-.328 1.166-1.545.512.244-.015.23.225.468.114-.005.304.235.34-.083.678.191.254 1.236-.278.709-.622-.314-1.01.161-1.453.451"
          fill="#FFA28F"
          fillRule="nonzero"
          transform="rotate(90 102.777 40.394)"
        />
        <Path
          d="M41.402 84.781c.035.51-.91.574-.551 1.22.484.871-.72.25-.641.754-.018-.326.664-1.721 1.192-1.974"
          fill="#FFA28F"
          fillRule="nonzero"
          transform="rotate(90 40.804 85.768)"
        />
        <Path
          d="M147.65 46.19c-.01.384.004.777-.359 1.036.066-.365.058-.756.36-1.037"
          fill="#FFA28F"
          fillRule="nonzero"
          transform="rotate(90 147.471 46.708)"
        />
        <Path
          d="M145.62 51.714c-.17-.01-.47.02-.486-.037-.126-.251.762-.126.487.037"
          fill="#020424"
          fillRule="nonzero"
          transform="rotate(90 145.398 51.624)"
        />
        <Path
          d="M83.817 56.058c.226-.112.423-.14.503.177a.673.673 0 01-.503-.177"
          fill="#020424"
          fillRule="nonzero"
          transform="rotate(90 84.068 56.108)"
        />
        <Path d="M104.23 40.213l-.17-.353.17.353" fill="#FFA28F" fillRule="nonzero" transform="rotate(90 104.145 40.037)" />
        <Path
          d="M83.595 56.15c.228-.018.37.036.464.256-.24.076-.364-.067-.464-.255"
          fill="#FFA28F"
          fillRule="nonzero"
          transform="rotate(90 83.827 56.287)"
        />
        <Path
          d="M103.361 40.849c-.036.318-.226.078-.34.084-.29-.253.18-.274.34-.084"
          fill="#020424"
          fillRule="nonzero"
          transform="rotate(90 103.145 40.868)"
        />
        <Path
          d="M151.208 43.99c.046-.056.082-.056.128 0-.046.056-.082.057-.128 0"
          fill="#FFA28F"
          fillRule="nonzero"
          transform="rotate(90 151.272 43.99)"
        />
        <Path
          d="M95.508 58.804c.063.123.087.227-.108.222l.108-.222"
          fill="#FFA28F"
          fillRule="nonzero"
          transform="rotate(90 95.477 58.915)"
        />
        <Path
          d="M33.87 70.113c-.398-1.306-1.125-.395-1.905-1.26-.027-.31-1.588.5-1.657.023.76-.636-.777-.113-1.036-.09-2.655 4.19 4.78 6.607 4.599 1.327"
          fill="#FE0403"
          fillRule="nonzero"
          transform="rotate(90 31.286 70.848)"
        />
        <Path
          d="M95.346 58.648c-.038.106-.04.203-.18.127l.18-.127"
          fill="#FFA28F"
          fillRule="nonzero"
          transform="rotate(90 95.255 58.725)"
        />
        <Path
          d="M103.813 40.274c-.023.017-.04.021-.058-.004.019-.014.073-.034.058.004"
          fill="#FFA28F"
          fillRule="nonzero"
          transform="rotate(90 103.785 40.27)"
        />
        <Path d="M83.49 56.868l.28.072-.28-.072" fill="#FFA28F" fillRule="nonzero" transform="rotate(90 83.63 56.904)" />
        <Path
          d="M136.059 45.538c.048.072.035.085-.038.037l.038-.037"
          fill="#FFA28F"
          fillRule="nonzero"
          transform="rotate(90 136.054 45.57)"
        />
        <Path d="M30.506 57.117l.016-.134-.016.134" fill="#FFA28F" fillRule="nonzero" transform="rotate(90 30.514 57.05)" />
        <Path d="M83.943 55.928l.15.124-.15-.124" fill="#FFA28F" fillRule="nonzero" transform="rotate(90 84.017 55.99)" />
        <Path
          d="M140.697 47.342l-.034-.025c.004 0 .03.04.034.025"
          fill="#FFA28F"
          fillRule="nonzero"
          transform="rotate(90 140.68 47.33)"
        />
        <Path
          d="M144.405 46.92c.108-.103.178.035.043.118-.022-.056-.054-.099-.043-.119m3.876 3.095c3.573-5.374-8.523-5.339-4.064.933.847.35.234 1.304.718 1.51.113-.013.302-.014.182.213.772-.453 4.273-2.033 2.939-2.543-.063-.21.11-.13.225-.113"
          fill="#FE0403"
          fillRule="nonzero"
          transform="rotate(90 146.084 49.388)"
        />
        <Path
          d="M142.822 48.092c.062-.03.155-.057.172-.107.091-.14-.348.07-.172.107"
          fill="#FE0403"
          fillRule="nonzero"
          transform="rotate(90 142.893 48.015)"
        />
        <Path
          d="M148.493 47.852c-.059-.109-.063-.145.051-.16.066.055.01.1-.051.16"
          fill="#020424"
          fillRule="nonzero"
          transform="rotate(90 148.513 47.772)"
        />
        <Path
          d="M138.384 69.605c-2.396.792-1.758 4.704.861 4.41 3.243-.353 2.766-5.916-.861-4.41"
          fill="#FE0403"
          fillRule="nonzero"
          transform="rotate(90 139.154 71.688)"
        />
        <Path
          d="M93.38 57.71c-1.76.01-2.71 1.87-2.979 3.49 2.238 6.85 10.255-2.001 2.978-3.49"
          fill="#FE0403"
          fillRule="nonzero"
          transform="rotate(90 93.385 60.74)"
        />
        <Path
          d="M102.9 40.573c.02-.044.047-.102.076-.037-.017.05-.033.1-.076.037"
          fill="#020424"
          fillRule="nonzero"
          transform="rotate(90 102.938 40.555)"
        />
        <Path
          d="M141.584 45.456c.318.037 2.191.206 1.274.466-.274-.572-1.135.398-1.274-.466"
          fill="#FFA28F"
          fillRule="nonzero"
          transform="rotate(90 142.346 45.689)"
        />
        <Path
          d="M142.34 44.522c.054.032.235.008.177.095-.06-.023-.123-.094-.177-.095"
          fill="#FFA28F"
          fillRule="nonzero"
          transform="rotate(90 142.434 44.57)"
        />
      </G>
    </Svg>
  );
};
